import AppWrapper from 'components/Layout/AppWrapper';
import { IEntity } from 'interfaces/entity';
import { IAppRoute } from 'interfaces/route';
import { IUserToken } from 'interfaces/userToken';
import React, { PureComponent } from 'react';
import { combineLatest } from 'rxjs';
import RxOp from 'rxjs-operators';
import authService from 'services/auth';
import categoryService from 'services/category';
import selectedVentureService, { ISelection } from 'services/profile';

import CategoryRouter from './categoryRoutes';
import Entity from './Entity';
import EntityRouter from './entityRouter';
import Router from './router';
import { SnapshotsProvider } from './Dashboard/context/SnapshotsContext';

interface IState {
  routes: IAppRoute[];
}

export default class AdminModule extends PureComponent<{}, IState> {
  static routes: IAppRoute[] = Router.routes;

  constructor(props: {}) {
    super(props);
    this.state = { routes: [] };
  }

  componentDidMount() {
    this.loadData();
  }

  updateRoutes = (user: IUserToken, selectedVenture: ISelection) => {
    const routes = Router.routes
      .filter((route) => user.canAccess(...route.roles))
      .filter(
        (route) => !(route.isProfileSelectedDependent && !selectedVenture)
      );
    this.setState({ routes });
    AdminModule.routes = routes;
  };

  loadData = () => {
    combineLatest([
      authService.getUser(),
      selectedVentureService.getSelectedVenture(),
    ])
      .pipe(RxOp.logError(), RxOp.bindComponent(this))
      .subscribe((value) => {
        const [user, selectedVenture] = value;
        if (!user || !selectedVenture) {
          this.setState({ routes: [] });
          return;
        }

        categoryService
          .fecthCategory(
            selectedVenture
              ? selectedVenture.id
              : user.ventures[0] && user.ventures[0].id
          )
          .pipe(RxOp.logError(), RxOp.bindComponent(this))
          .subscribe(({ data = [] }) => {
            data = data || [];
            const entityRoutes = data.map((category) => {
              const CurrentEntityRouter = (props: any) => (
                <EntityRouter {...props} />
              );
              const childrenRoutes = this.getEntityRouterRoutes(
                selectedVenture.id,
                category.children
              );

              CurrentEntityRouter.routes = childrenRoutes;

              return {
                path: `/venture/${selectedVenture.id}/entity/${category.id}`,
                sideDrawer: { display: category.name },
                component: CurrentEntityRouter,
              } as IAppRoute;
            });
            CategoryRouter.routes = entityRoutes;
            this.updateRoutes(user, selectedVenture);
          });
        this.updateRoutes(user, selectedVenture);
      });
  };

  getEntityRouterRoutes(
    selectedVentureId: number,
    entitiesGraph?: IEntity[]
  ): IAppRoute[] {
    return entitiesGraph
      ? (entitiesGraph
          .filter(
            (entity) =>
              entity.parentId === null &&
              (entity.ventureId === selectedVentureId ||
                entity.ventureId === null)
          )
          .sort((a, b) => {
            if (a.name < b.name) return -1;
            if (a.name > b.name) return 1;
            return 0;
          })
          .sort((a, b) => {
            if (a.order < b.order) return -1;
            if (a.order > b.order) return 1;
            return 0;
          })
          .map((entity) => ({
            path: `/venture/${selectedVentureId}/entity/${entity.id}`,
            sideDrawer: { display: entity.name },
            component: Entity,
          })) as IAppRoute[])
      : [];
  }

  render() {
    const { routes } = this.state;

    return (
      <AppWrapper routes={routes}>
        <SnapshotsProvider>{this.props.children}</SnapshotsProvider>
      </AppWrapper>
    );
  }
}
